import axios, { AxiosResponse } from "axios";

import Utils, { ResponseWrapper, ServerModelWithDateStrings } from "@teamprevent/common/utils";

import {
    CustomMedicalTypeDetailModel,
    CustomMedicalTypeListModel } from "./models";
import { CustomMedicalTypeFormModel } from "./schema";

const apiUrl = "/api/customMedicalTypes";

const getAll = async (): Promise<CustomMedicalTypeListModel[]> => {
    const response = await axios.get<ServerModelWithDateStrings<CustomMedicalTypeListModel[]>>(apiUrl);
    return response.data;
};

const get = async (id: string): Promise<CustomMedicalTypeDetailModel> => {
    const response = await axios.get<ServerModelWithDateStrings<CustomMedicalTypeDetailModel>>(`${apiUrl}/${id}`);
    return response.data;
};

const create = async (customMedicalType: CustomMedicalTypeFormModel): Promise<CustomMedicalTypeListModel | null> => {
    const response = await axios.post<
        ResponseWrapper<CustomMedicalTypeListModel>,
        AxiosResponse<ResponseWrapper<CustomMedicalTypeListModel>>,
        CustomMedicalTypeFormModel>(`${apiUrl}`, customMedicalType);

    const result = Utils.CheckResponse<CustomMedicalTypeListModel>(response.data);

    if (!result)
    {
        return null;
    }

    return result;
};

export const CustomMedicalTypeApi = { getAll, get, create };
